import React from "react";
import { IconProps } from "../icon";

export const SearchRefractionIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 21l-4.35-4.35M11 6a5 5 0 015 5m3 0a8 8 0 11-16 0 8 8 0 0116 0z"
    />
  </svg>
);
